/**
 * A venue address counts as "located" only when BOTH coordinates are real numbers.
 * Truthy checks are wrong here: 0 is a valid latitude and a valid longitude.
 *
 * Accepts `unknown` because the form values are loosely typed (`strict: false`)
 * and the geocoder can hand back anything; the semantics stay the same: both
 * values must be finite numbers.
 */
export function hasValidCoordinates(lat?: unknown, lon?: unknown): boolean {
  return Number.isFinite(lat) && Number.isFinite(lon);
}
